<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import iView from 'iview'
  export default {
    name: 'App'
  }

</script>

<style scoped>
</style>

<style>
  html {
    width: 100%;
    height: 100%;
  }

  body {
    width: 100%;
    height: 100%;
    margin: 0;
  }

  /* absolute center */
  .a-center {
    top: 50%;
    transform: translateY(-50%);
  }

  .relativeContainer {
    position: relative;
  }

  .absoluteContainer {
    position: absolute;
  }

  .percent100 {
    width: 100%;
    height: 100%;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  /*滚动条样式*/
  html ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }

  html ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.4);
  }

  html ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(156, 183, 214, 0.97);
  }

  .over-hidden {
    overflow: hidden;
  }

  .no-event {
    pointer-events: none;
  }

  .ellipse {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .scroll-ol {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
  }

  .scroll-text {
    white-space: nowrap;
    display: block;
  }

  .scroll-ol:hover .scroll-text {
    animation-name: scroll;
    animation-duration: 10s;
    animation-delay: 0ms;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    -webkit-animation-name: scroll;
    -webkit-animation-delay: 0ms;
    -webkit-animation-duration: 10s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-name: scroll;
    -moz-animation-delay: 0ms;
    -moz-animation-duration: 10s;
    -moz-animation-timing-function: linear;
    -moz-animation-iteration-count: infinite;
  }

  @-webkit-keyframes scroll {
    0% {
      -webkit-transform: translate3d(-0, 0, 0);
      transform: translate3d(-0, 0, 0);
    }

    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      display: none;
    }
  }

  @-moz-keyframes scroll {
    0% {
      -webkit-transform: translate3d(-0, 0, 0);
      transform: translate3d(-0, 0, 0);
    }

    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      display: none;
    }
  }

  @-ms-keyframes scroll {
    0% {
      -webkit-transform: translate3d(-0, 0, 0);
      transform: translate3d(-0, 0, 0);
    }

    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      display: none;
    }
  }

  @keyframes scroll {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
      display: none;
    }
  }

  .noteMap {
    color: #6f91c3;
    font-size: 14px;
    float: right;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: relative;
    width: 100%;
    height: 100%;
    float: left;
  }

  /** leaflet 重置 */
  .leaflet-control-scale-line {
    border: 1px solid #447da5 !important;
    background: rgba(255, 255, 255, 0) !important;
    border-top: none !important;
  }

  .leaflet-control-scale-line {
    color: #fff !important;
  }

  .leaflet-bar a:hover {
    background-color: #447da5;
  }

  .leaflet-bar a,
  .leaflet-bar a:hover {
    background-color: #11333c !important;
    color: white !important;
  }

  .leaflet-control-minimap {
    border: solid #013d53 3px !important;
    box-shadow: 0 1px 7px #999;
    background: #013d53 !important;
    -moz-border-radius: 100px 5px 100px 100px !important;
    -webkit-border-radius: 100px 5px 100px 100px !important;
    border-radius: 100px 5px 100px 100px !important;
    transition: all .2s;
  }

  .leaflet-control-minimap a {
    background-color: #013d53 !important;
    background-position: 1px 2px;
    background-repeat: no-repeat;
    display: block;
    outline: none;
    z-index: 1000;
    transition: all .2s;
  }


  .popup-label {
    width: 80px;
  }

  .popup-data {
    width: 180px
  }

  .popup-btn {
    width: 100%;
    text-align: center;
    background: #cbe2fa;
    height: 26px;
    line-height: 26px;
    margin-top: 3px;
  }

  .popup-btn:hover {
    background: #96b5d6;
  }

  .leaflet-popup-content-wrapper {
    border-radius: 4px;
  }

  .leaflet-popup-content {
    margin: 10px;
  }

  .popup-contianer {
    width: 100%;
  }

  .leaflet-popup-content {
    /* height: 170px; */
    width: 260px !important;
    font-size: 14px;
    margin: 10px 15px;
    overflow: hidden;
  }

  .popup-row {
    width: 100%;
    margin-top: 6px;
  }

  .leaflet-control {
    float: left;
    clear: none;
  }

  .popup-title {
    font-size: 18px;
    color: #004a8a;
  }

  .text-icon {
    font-size: 17px;
    font-weight: 200;
    color: #ffffff;
    width: 200px !important;
  }

  /** leaflet 重置 */
  .leaflet-control-scale-line {
    border: 1px solid #447da5;
    background: rgba(255, 255, 255, 0);
    border-top: none;
  }

  .leaflet-control-scale-line {
    color: #fff;
  }

  .leaflet-bar a:hover {
    background-color: #447da5;
  }

  .leaflet-bar a,
  .leaflet-bar a:hover {
    background-color: #11333c;
    color: white;
  }

  .leaflet-control {
    float: left;
    clear: none;
  }

  .text-icon {
    font-size: 17px;
    font-weight: 200;
    color: #ffffff;
    width: 200px !important;
  }


  .map-query-form .ivu-form-item {
    margin-bottom: 10px !important;
  }

  .reset .ivu-page-item {
    background-color: rgba(44, 76, 93, 0.7);
  }

  .reset .ivu-page-next,
  .reset .ivu-page-prev {
    background-color: rgba(44, 76, 93, 0.7);
    border: 1px solid #27536e;
  }

  .reset .ivu-page-options-elevator input {
    background-color: rgba(44, 76, 93, 0.7);
    color: white;
  }

  .reset .ivu-page.mini .ivu-page-item {
    border: 1px solid #27536e;
  }

  .reset .ivu-page.mini .ivu-page-next,
  .reset .ivu-page.mini .ivu-page-prev {
    border: 1px solid #27536e;
  }

  .reset .ivu-page.mini .ivu-page-options-elevator input {
    border: 1px solid #27536e;
  }

  .reset {
    background-color: rgba(8, 8, 4, 0.8) !important;
    color: white !important;
  }

  .reset .ivu-form .ivu-form-item-label {
    color: white !important;
    background-color: rgba(26, 60, 78, 0.8);
    width: 50px !important;
    padding: 6px 12px 6px 0;
  }

  .first .ivu-form-item-label {
    height: 50px;
    line-height: 38px;
  }

  .second .ivu-form-item-label {
    height: 58px;
    line-height: 48px;
  }

  .reset .ivu-select-dropdown {
    background-color: rgba(17, 51, 60, 0.9) !important;
    /* right: 0px; */
  }

  .reset .ivu-form-item-content {
    line-height: 24px;
  }

  /* .reset .ivu-cascader-menu .ivu-cascader-menu-item{
    padding-right: 24px;
  } */

  .reset .ivu-cascader .ivu-cascader-menu-item {
    color: white;
    text-align: left;
    padding: 7px 16px;
  }

  .reset .ivu-cascader-menu {
    border-right: unset;
    width: 130px;
  }

  .reset .ivu-cascader .ivu-cascader-menu-item:hover {
    background: #0075ad;
  }

  .reset .ivu-cascader-menu .ivu-cascader-menu-item-active {
    background-color: #2b6cff;
  }

  .reset .ivu-input-prefix i,
  .reset .ivu-input-suffix i {
    line-height: 24px;
  }

  .textIndext {
    text-indent: 2em;
  }

  /**
  reset
  */
  /* 主色调 #080804 */
  /* 对比调 #013d53 */
  .reset .ivu-table-cell {
    padding-left: 10px;
    padding-right: 10px;
  }

  .reset .ivu-table {
    background-color: unset;
  }

  .reset .ivu-table table {
    border-collapse: collapse !important;
  }

  .reset .ivu-table td {
    height: 30px;
    background-color: rgba(20, 52, 59, 0.7);
    color: white;
    /* border-left: 3px solid #cbe2fa; */
    border-bottom: unset;
  }

  .reset .ivu-table th {
    height: 30px;
    background-color: unset;
    color: white;
    border-bottom: unset;
  }

  /* .reset .ivu-table-row-highlight{
  background-color: black;
} */

  .reset .ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background-color: rgba(44, 76, 93, 0.7);
  }

  .reset .ivu-table-stripe .ivu-table-body tr.ivu-table-row-highlight td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-highlight td {
    background-color: #00528c;
  }

  .reset .ivu-table-stripe .ivu-table-body tr:nth-child(2n+1) {
    border-left: 1px solid #fcfe4b;
  }

  .reset .ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: unset;
  }

  .reset .ivu-table-stripe .ivu-table-body tr:nth-child(2n).ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n).ivu-table-row-hover td {
    background-color: rgba(44, 76, 93, 0.7);
  }

  .reset .ivu-table-stripe .ivu-table-body tr:nth-child(2n).ivu-table-row-highlight td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n).ivu-table-row-highlight td {
    background-color: #00528c;
  }

  .reset .ivu-table-wrapper {
    border: none;
  }

  .reset .ivu-table-border td,
  .reset .ivu-table-border th {
    border: none;
  }

  .reset .ivu-table:before,
  .reset .ivu-table-fixed-right::before,
  .reset .ivu-table-fixed::before {
    height: unset;
  }

  .reset .ivu-table-fixed-right-header {
    width: 0 !important;
  }

  .reset .ivu-table:after {
    width: 0 !important;
  }

  .reset .ivu-form-item {
    margin-bottom: 10px;
  }

  .reset .ivu-select-selected-value {
    color: white;
  }

  .reset .ivu-input[disabled],
  fieldset[disabled] .ivu-input {
    color: #a39a9a;
    background-color: #205c6c;
  }

  .reset .ivu-form-item-label {
    color: white;
  }

  .reset .ivu-radio-wrapper {
    color: white;
  }

  .reset .ivu-input {
    color: #ffffff;
    background-color: rgba(17, 51, 60, 0.6);
    border-radius: unset;
    border: 1px solid #27536e;
    height: 24px;
  }

  .reset .ivu-input:hover {
    border: 1px solid #38b3ff;
  }

  .reset .ivu-input-group-prepend {
    color: #ffffff;
    background-color: #11333c;
  }

  .reset .ivu-input-group-append {
    color: #ffffff;
    background-color: #11333c;
  }

  .reset .ivu-date-picker-cells span em {
    color: #ffffff;
  }

  .reset .ivu-time-picker-cells-list ul li {
    color: #ffffff;
  }

  .reset .ivu-time-picker-cells-cell-selected,
  .ivu-time-picker-cells-cell-selected:hover {
    background: #38525c;
  }

  .reset .ivu-picker-confirm-time {
    color: #ffffff;
  }

  .reset .ivu-cascader-label {
    text-align: left;
    padding: 0px 16px;
    line-height: 26px;
  }

  /* .reset .ivu-input-type:hover{
  border: 1px solid #38b3ff;
} */

  .reset .ivu-btn {
    border: 1px solid #27536e;
  }

  .reset .ivu-btn:hover {
    border: 1px solid #38b3ff;
  }

  .reset .ivu-radio-inner {
    background-color: unset;
    border: 1px solid #27536e;
  }

  .reset .ivu-radio-inner:hover {
    border: 1px solid #38b3ff;
  }

  .ivu-notice {
    z-index: 2000 !important;
  }

  .leaflet-popup-content-wrapper,
  .leaflet-popup-tip {
    background: rgba(255, 255, 255) !important;
  }

  .leaflet-popup-content-wrapper {
    border-radius: 10px !important;
  }

  /* 点击使气泡显示自适应 */
  .leaflet-popup {
    /* padding: 50px 0px 0px 200px;
    left: -350px !important; */
    padding: 50px 200px 0px 200px;
    left: -350px !important;
  }

  .leaflet-container a.leaflet-popup-close-button {
    top: 54px !important;
    right: 205px !important;
  }

  .leaflet-popup-tip-container {
    left: 349px !important;
  }

  .ivu-tooltip-popper {
    pointer-events: none;
  }

  .leaflet-container {
    background: #1b3b66 !important;
  }

  /* //  Tooltip 容器  */
  .tooltip {
    position: relative;
    display: inline-block;
    /* // border-bottom: 1px dotted black; 悬停元素上显示点线 */
  }

  /* // Tooltip 文本  */
  .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;

    /* // 定位 */
    position: absolute;
    z-index: 1;

    /* width: 120px;
    top: 100%;
    left: 50%; 
    margin-left: -60px; */
    top: -5px;
    left: 105%;
  }

  /* // 鼠标移动上去后显示提示框  */
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  .leaflet-touch .leaflet-bar a {
    width: 50px !important;
    height: 40px !important;
    line-height: 40px !important;
  }

  @media screen and (min-width: 1367px) {

    .retrievalBody .ivu-table td,
    .retrievalBody .ivu-table th {
      height: 54px;
    }

    .showDetail .ivu-modal,
    .showRelevant .ivu-modal {
      bottom: 95px !important;
    }

    .showDetail .detailRow,
    .relevantDetail .detailRow {
      padding-right: 85px !important;
    }

    .showDetail .detail-row {
      margin-top: 20px !important;
    }

    .listTitle {
      margin-bottom: 10px;
      margin-top: 10px;
    }

    .listTable .ivu-table td,
    .listTable .ivu-table th {
      height: 58px;
    }

    .panel-title .param {
      width: 890px !important;
    }

    .panel-title .param .ivu-form-item-content {
      margin-left: 90px !important;
    }

    .panel-title .param .ivu-form .ivu-form-item-label {
      padding: 10px 0px 10px 0;
    }

    .panel-title .param .ivu-col-span-6 {
      width: 160px !important;
    }

    .panel-title .param .ivu-col-span-17 {
      width: 400px !important;
    }

    .panel-title .param .ivu-col-span-10 {
      width: 220px !important;
    }

    .disasterTrace .ivu-back-top {
      right: 300px !important;
    }

    .disasterTrace .panel-icon {
      right: 400px !important;
    }

    .disasterTrace .panel-icon-statistic {
      right: 10px !important;
    }

    /* .tooltip {
    position: relative;
    color: #333;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }

  .popup-contianer .tooltip:hover::before {
    word-break: keep-all;
    white-space: nowrap;
    content: attr(data-msg);
    position: absolute;
    padding: 2px 6px;
    display: block;
    color: #333;
    border: 1px solid #333;
    border-radius: 5px;
    font-size: 14px;
    line-height: 20px;
  }

  .popup-contianer .tooltip:hover::after {
    content: "";
    position: absolute;
  }

  .popup-contianer .tooltip-down:hover::before {
    bottom: -30px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .popup-contianer .tooltip-down:hover::after {
    border-bottom: 5px solid #333;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    bottom: -5px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
  } */

  }

</style>



// WEBPACK FOOTER //
// src/App.vue